import classNames from 'classnames';
import { Icon } from '@zambezi/sdk/icons';
import { MILESTONE_STATUSES } from 'constants/constants';
import { Button } from '@hbo/ui-servicing-react-components';

interface MilestoneButtonProps {
  title: string;
  status: string;
  isComplete: boolean;
  onClick: () => void;
}

const MilestoneButton: React.FC<MilestoneButtonProps> = ({
  title,
  status,
  isComplete,
  onClick
}: MilestoneButtonProps) => {
  return (
    <tr>
      <th>
        <div className="milestone-status">
          <Button variant="link" onClick={onClick}>
            {title}
          </Button>
        </div>
      </th>
      <td>
        <div className="milestone-status">
          {status === MILESTONE_STATUSES.CANCELLED_DECLINED ? (
            <Icon name="error-xlarge" title="Cancelled/Declined" />
          ) : (
            <>
              {status === MILESTONE_STATUSES.IN_PROGRESS && (
                <div className="in-progress-indicatorDot" title="In Progress"></div>
              )}
              {status === MILESTONE_STATUSES.NOT_STARTED && (
                <div className="not-started-indicatorDot" title="Not Started"></div>
              )}
              {status === MILESTONE_STATUSES.COMPLETED && (
                <Icon name="confirmation-xlarge" title="Completed" />
              )}
              {status === MILESTONE_STATUSES.ACTION_REQUIRED && (
                <Icon name="warning-xlarge" title="Action Required" />
              )}
            </>
          )}
          <span>{status}</span>
        </div>
      </td>
    </tr>
  );
};

export default MilestoneButton;
